export function formatInteger(value, fieldConfig) {
	if(!value && value !== 0) {
		return value;
	}

	if(typeof value !== 'number') {
		value = Number(value);
	}

	if(isNaN(value)) {
		return 0;
	}

	value = Math.round(value);

	if(typeof fieldConfig.minNumber === 'number' && value < fieldConfig.minNumber) {
		return Math.round(fieldConfig.minNumber);
	}

	if(typeof fieldConfig.maxNumber === 'number' && value > fieldConfig.maxNumber) {
		return Math.round(fieldConfig.maxNumber);
	}

	return value;
}


export function formatDecimal(value, fieldConfig) {
	if(!value && value !== 0) {
		return value;
	}

	if(typeof value !== 'number') {
		value = Number(value);
	}

	if(isNaN(value)) {
		return 0;
	}

	const { precision = 2 } = fieldConfig;

	if(typeof fieldConfig.minNumber === 'number' && value < fieldConfig.minNumber) {
		return fieldConfig.minNumber.toFixed(precision);
	}

	if(typeof fieldConfig.maxNumber === 'number' && value > fieldConfig.maxNumber) {
		return fieldConfig.maxNumber.toFixed(precision);
	}

	return value.toFixed(precision);
}


export function formatValue(value, fieldConfig) {
	switch(fieldConfig.inputType) {
		case 'integer':
			return formatInteger(value, fieldConfig);
		case 'decimal':
			return formatDecimal(value, fieldConfig);
		default:
			return value;
	}
}
